export const appConstants = {
  FLASH_MESSAGE_TIMEOUT: 4000,
  META_TITLE_SUFFIX: 'Spoil Me',

  TOUCH_BREAKPOINT: 768,

  SEARCH_MAX_RESULTS: 5
}
